.mcfx-subscription-info {
    margin: 16px;
}

.content {
    padding: 0 16px;
}
